import * as user from './user';
import * as account from './account';
import * as device from './device';
import * as vehicle from './vehicle';
import * as dashboard from './dashboard';
import * as sim from './sim';
import * as notification from './notification';
import * as language from './language';
import * as dtMapping from './dtMapping';

const API = { user, account, device, vehicle, dashboard, sim, notification, language, dtMapping };

export default API;



// WEBPACK FOOTER //
// ./src/api/index.js